import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';

const messages = defineMessages({
  administrator: { id: 'attrs.role.administrator', defaultMessage: 'Administrator' },
  owner: { id: 'attrs.role.owner', defaultMessage: 'Owner' },
  externalSupport: { id: 'attrs.role.external-support', defaultMessage: 'External Support' },
  user: { id: 'attrs.role.user', defaultMessage: 'User' },
  multiFactorAuthenticationNotEnabled: {
    id: 'profile.multiFactorAuthentication.notEnabled',
    defaultMessage: 'Not enabled',
  },
});

const UserDetails = ({ user, userRole }) => {
  const { formatMessage } = useIntl();
  const {
    cldr: { localeDisplayName, teritoryDisplayName },
  } = useSelector((state) => state.i18n);

  const getRoleTranslation = () => {
    switch (userRole) {
      case 'admin':
      case 'nbm-admin':
        return <span>{formatMessage(messages.administrator)}</span>;
      case 'owner':
      case 'nbm-owner':
        return <span>{formatMessage(messages.owner)}</span>;
      case 'external-support':
      case 'nbm-external-support':
        return <span>{formatMessage(messages.externalSupport)}</span>;
      case 'member':
      case 'nbm-member':
        return <span>{formatMessage(messages.user)}</span>;
      default:
        return '';
    }
  };

  const locale = localeDisplayName(user.locale);
  const country = teritoryDisplayName(user.country);
  const role = getRoleTranslation();

  const multiFactorAuthenticationOption =
    user.currentMultiFactorAuthenticationOption || formatMessage(messages.multiFactorAuthenticationNotEnabled);

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <p>
          <FormattedMessage id="profile.email" defaultMessage="Email" tagName="strong" />
          <span>
            {': '}
            {user.email}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.locale" defaultMessage="Preferred language" tagName="strong" />
          <span>
            {': '}
            {locale}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.country" defaultMessage="Country" tagName="strong" />
          <span>
            {': '}
            {country}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.timezone" defaultMessage="Time zone" tagName="strong" />
          <span>
            {': '}
            {user.timeZone}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.role" defaultMessage="Role for current account" tagName="strong" />
          <span>
            {': '}
            {role}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.createdOn" defaultMessage="Created on" tagName="strong" />
          <span>
            {': '}
            {user.createdOn && <Gr8piFormattedDate dateValue={user.createdOn} />}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.enabled" defaultMessage="Enabled" tagName="strong" />
          <span>
            {': '}
            {String(user.enabled)}
          </span>
        </p>
        <p>
          <FormattedMessage id="profile.emailVerified" defaultMessage="Email verified" tagName="strong" />
          <span>
            {': '}
            {String(user.emailVerified)}
          </span>
        </p>
        <p>
          <FormattedMessage
            id="profile.multiFactorAuthentication"
            defaultMessage="Multi factor authentication"
            tagName="strong"
          />
          <span>
            {': '}
            {multiFactorAuthenticationOption}
          </span>
        </p>
      </div>
    </div>
  );
};

export default UserDetails;
